import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './BtnLoad.css'
import template from './BtnLoad.jinja'

var BtnLoad = Backbone.View.extend({
    initialize () {
    }
})

export default BtnLoad


// WEBPACK FOOTER //
// ./assets/app/front/components/BtnLoad/BtnLoad.js